import Assert from "tbAssert";
import UiRouterModule from "@uirouter/angularjs";

import TrackingCalendarViewModuleConstants from "tbClient/views/tracking-calendar-view/Constants";
import AuthServiceModuleConstants from "tbClient/services/auth/AuthConstants";
import AuthServiceModule from "tbClient/services/auth";
import TbLoginViewConstants from "tbClient/views/tb-login-view/Constants";

const mLogSvc = new WeakMap();
const mUiRouterStateSvc = new WeakMap();
const mAuthSvc = new WeakMap();

class AuthCallbackController {
    constructor($log, $state, TbAuthService) {
        Assert.StrictAssert($log != null, "Callback missing log service dependency");
        Assert.StrictAssert($state != null, "Callback missing ui router state service dependency");
        Assert.StrictAssert(TbAuthService != null, "Callback missing auth service dependency");

        mLogSvc.set(this, $log);
        mUiRouterStateSvc.set(this, $state);
        mAuthSvc.set(this, TbAuthService);
    }

    $onInit() {
        const logSvc = mLogSvc.get(this);
        const stateSvc = mUiRouterStateSvc.get(this);
        const authSvc = mAuthSvc.get(this);

        logSvc.debug("In Auth Callback. Processing authentication...");
        
        // DEBUG: Log the current URL to see what OneLogin sent us
        logSvc.debug("=== AUTH CALLBACK DEBUG ===");
        logSvc.debug("Current URL:", window.location.href);
        logSvc.debug("URL Hash:", window.location.hash);
        logSvc.debug("URL Search:", window.location.search);
        logSvc.debug("=== END AUTH CALLBACK DEBUG ===");

        // Handle the OneLogin authentication callback
        authSvc.handleAuthentication()
            .then((authResult) => {
                if (authResult && authResult.accessToken) {
                    logSvc.debug("Authentication successful:", authResult);
                    
                    // Store tokens
                    localStorage.setItem(AuthServiceModuleConstants.storageKeys.accessTokenKey, authResult.accessToken);
                    if (authResult.idToken) {
                        localStorage.setItem(AuthServiceModuleConstants.storageKeys.idTokenKey, authResult.idToken);
                    }
                    
                    // Redirect to main application
                    logSvc.debug("Redirecting to Calendar.");
                    stateSvc.go(TrackingCalendarViewModuleConstants.rootStateName);
                } else {
                    logSvc.error("Authentication failed - no tokens received");
                    logSvc.error("authResult was:", authResult);
                    stateSvc.go(TbLoginViewConstants.rootStateName);
                }
            })
            .catch((error) => {
                logSvc.error("Authentication error:", error);
                stateSvc.go(TbLoginViewConstants.rootStateName);
            });
    }
}

AuthCallbackController.$inject = [
    "$log",
    "$state",
    "TbAuthService"
];

AuthCallbackController.template = require("./AuthCallback.tpl.html");
AuthCallbackController.controllerAs = "authCallback";

AuthCallbackController.dependencies = [
    UiRouterModule,
    AuthServiceModule
];

export default AuthCallbackController;



//////////////////
// WEBPACK FOOTER
// ./src/views/auth-callback/AuthCallbackController.js
// module id = k8nd
// module chunks = 1